import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

const INSIGHTS_GRID_COLUMNS = 3;

export type InsightsGridColumnSpan = 1 | 2 | 3;

type InsightsGridProps = {
  children: ReactNode;
};

export const InsightsGrid = ({ children }: InsightsGridProps) => (
  <Box
    data-test="insights-grid"
    sx={{
      display: 'grid',
      gap: 1,
      gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: `repeat(${INSIGHTS_GRID_COLUMNS}, minmax(0, 1fr))` },
      p: 2,
    }}
  >
    {children}
  </Box>
);
